import { put, call, takeLatest, all } from 'redux-saga/effects';

import { error, manualClearError } from 'notifications/actions';
import * as api from './api';
import * as types from './types';
import * as actions from './actions';
import { paymentArrangementRequest } from '../app/routes';

export function* arrangePayment({ payload: { purchaseId, attrs } }) {
  try {
    yield put(manualClearError('paymentArrangementRequest'));
    yield put(actions.arrangePaymentPending());
    const resp = yield call(api.arrangePurchase, purchaseId, attrs);
    yield put(actions.arrangePaymentSucceeded(resp));
    yield put(paymentArrangementRequest({ success: 'true' }));
  }
  catch (err) {
    yield put(actions.arrangePaymentFailed());
    let errorMessage; 
    if (err.response && err.response.data) {
      const data = err.response.data;
      errorMessage = data.total || data.detail || data.message; 
    }
    
    const default409ErrorMessage = 'You are not eligible to request a payment arrangement for this purchase. Please pay your outstanding balance to avoid service restrictions.';
    if (errorMessage === 'Payment arrangement is not allowed.') {
      yield put(error('paymentArrangementRequest', default409ErrorMessage, false));
    } else if (errorMessage) {
      yield put(error('paymentArrangementRequest', errorMessage, false));
    } else if (err.response && err.response.status === 409) {
      yield put(error('paymentArrangementRequest', default409ErrorMessage, false));
    } else {
      yield put(error('paymentArrangementRequest', err.message));
    }
  }
}

export function* watchArrangePayment() {
  yield takeLatest(types.ARRANGE_PAYMENT, arrangePayment);
}

export function* watchPaymentArrangement() {
  yield all([
    call(watchArrangePayment),
  ]);
}